<template>
  <v-container>
    <v-row align-content="center" justify="center">
      <v-col cols="6">
        <v-alert prominent type="error">
          <template v-if="errorCode == '403'">
            You do not have the required permission to the desired action.
            Please contact your administrator.
          </template>
          <template v-if="errorCode == '404'">
            The page you tried to access does not exist.
          </template>
          <template v-if="errorCode == 'api'">
            The server is currently unavailable.
          </template>
          <template v-if="errorMessage">
            {{ errorMessage }}
          </template>
          <router-link v-if="redirectTo && errorCode != 'api'" :to="redirectTo"
            >Go Back</router-link
          >
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Error',
  props: {
    errorCode: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default () {
        return ''
      }
    },
    redirectTo: {
      type: Object,
      default () {
        return this.$store.state.previousRoute
      }
    }
  }
}
</script>

<style></style>
